import React from 'react'
import { cn } from './cn'

export interface KbdProps extends React.HTMLAttributes<HTMLElement> {
  /** 這個鍵就是畫面主角時（引導頁「按住 fn 說話」）用大一號。 */
  large?: boolean
  /** 鍵帽在墨底上（桌面錄音膠囊的「再按一次 Esc」）：只描邊，不填紙白。 */
  onInk?: boolean
}

/**
 * 按鍵帽：描邊、下緣多一條線，看得出是「鍵」（設計側 css/kiao-desktop-sleek.css 的
 * `.key`）。只畫一個鍵；組合鍵由呼叫端排多個。字用內文 Sans 而不是 mono，跟著
 * App 面「數字跟內文走」的規則。
 */
export function Kbd({ large = false, onInk = false, className, ...rest }: KbdProps) {
  return (
    <kbd
      {...rest}
      className={cn(
        'inline-flex items-center whitespace-nowrap rounded-[var(--radius-sm)] border font-sans font-medium tabular-nums',
        onInk
          ? 'h-5 px-1.5 text-xs border-[var(--on-ink-line)] bg-transparent text-[var(--on-ink)]'
          : cn(
              'border-border bg-background text-foreground shadow-[0_1px_0_var(--line-strong)]',
              large ? 'h-7.5 px-2.5 text-sm' : 'h-6 px-2 text-xs'
            ),
        className
      )}
    />
  )
}
